import { render, staticRenderFns } from "./ResponderComunicacaoEletronica.vue?vue&type=template&id=10aade16&scoped=true"
import script from "./ResponderComunicacaoEletronica.vue?vue&type=script&lang=ts"
export * from "./ResponderComunicacaoEletronica.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aade16",
  null
  
)

export default component.exports